import { collection, getDocs, limit, query, where } from 'firebase/firestore'
import { db } from '../firebase-config'

function pickCanonical(docs = []) {
  if (!Array.isArray(docs) || !docs.length) return null
  const scored = docs.map((docSnap) => {
    const data = docSnap.data() || {}
    const uid = String(data.uid || '').trim()
    const id = String(docSnap.id || '').trim()
    const isAdmin = data.admin === true || String(data.role || '') === 'admin'
    const active = data.active !== false
    const isLegacy = String(data.merge_status || '').toLowerCase() === 'legacy' || Boolean(data.merged_into)
    const updatedAt = Number(data?.updatedAt?.toMillis?.() || 0)
    const score = (uid && uid === id ? 100 : 0) + (isAdmin ? 10 : 0) + (uid ? 5 : 0) + (active ? 3 : 0) + (isLegacy ? -50 : 0)
    return { docSnap, data, score, updatedAt }
  })
  scored.sort((a, b) => (b.score - a.score) || (b.updatedAt - a.updatedAt))
  return scored[0]
}

export function sanitizeDni(dni) {
  return String(dni || '').replace(/[.\-\s]/g, '').replace(/\D/g, '')
}

export async function resolveEmailByDni(dni) {
  const clean = sanitizeDni(dni)
  if (!clean) return null

  const q = query(
    collection(db, 'users'),
    where('dni', '==', clean),
    limit(1)
  )
  const snap = await getDocs(q)
  if (snap.empty) return null
  const data = snap.docs[0].data() || {}
  return data.email || null
}

export async function getCurrentUserRole(userIdentifier) {
  const raw = String(userIdentifier || '').trim()
  const id = sanitizeDni(raw)
  const rawLower = raw.toLowerCase()
  const isEmail = rawLower.includes('@')
  const looksLikeUid = /[a-z]/i.test(raw)
  const looksNumericOnly = /^\d+$/.test(raw)

  let snap = { empty: true }

  if (looksLikeUid) {
    const byUid = query(collection(db, 'users'), where('uid', '==', raw), limit(10))
    snap = await getDocs(byUid)
    if (snap.empty) {
      const byUidLower = query(collection(db, 'users'), where('uid', '==', rawLower), limit(10))
      snap = await getDocs(byUidLower)
    }
  }

  if (snap.empty && isEmail) {
    const byEmail = query(collection(db, 'users'), where('email', '==', rawLower), limit(10))
    snap = await getDocs(byEmail)
  }

  if (snap.empty && id && looksNumericOnly) {
    const byDni = query(collection(db, 'users'), where('dni', '==', id), limit(1))
    snap = await getDocs(byDni)

    if (snap.empty) {
      const byCuit = query(collection(db, 'users'), where('cuit', '==', id), limit(1))
      snap = await getDocs(byCuit)
    }
  }

  if (snap.empty && raw && !looksLikeUid && !isEmail) {
    const byUid = query(collection(db, 'users'), where('uid', '==', raw), limit(10))
    snap = await getDocs(byUid)
  }

  if (snap.empty) return { role: 'user', isAdmin: false }

  const picked = pickCanonical(snap.docs)
  const data = picked?.data || {}
  const role = data.role || data.rol || (data.admin ? 'admin' : 'user')
  return { role, isAdmin: role === 'admin' || data.admin === true }
}
